export default __webpack_public_path__ + "static/media/cloud_dev_img.fad338e8.svg";